import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAWgtXjthW9_1_NWyqp3P-c9xUyd8lwKiQ",
    authDomain: "linkedin-clone-fb083.firebaseapp.com",
    projectId: "linkedin-clone-fb083",
    storageBucket: "linkedin-clone-fb083.appspot.com",
    messagingSenderId: "402614056446",
    appId: "1:402614056446:web:636d23f493975736ebfcaf"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { auth, db };
